<template>
  <IndexPanel
    v-if="listItems.length > 0"
    :initialData="listItems"
    :modelValue="searchResults"
    operationType="plants"
  />

  <OperationList
    v-slot="slotProps"
    :listItems="searchResults"
    operationType="plants"
  >
    <OperationItem
      v-for="item in slotProps.item.plants"
      :id="item.id"
      :key="item.id"
      barChart
      endpointIdentifier="operations"
      :itemRoutes="{
        view: { name: 'operation', params: { operationId: item.id } },
        edit: { name: 'configurationPlants', params: { organisationId: props.organisationId, operationId: item.id } },
      }"
      :organisationId="organisationId"
      @reload="reload"
    />
  </OperationList>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import useAjax from '@/functions/use_ajax';

// Components
import OperationList from '@/components/operations/operations_list.vue';
import OperationItem from '@/components/operations/operation_item.vue';
import IndexPanel from '@/components/form/index_panel.vue';

const emit = defineEmits(['update']);

const props = defineProps({
  organisationId: { type: String, default: null },
});

const ajax = useAjax();
const listItems = ref([]);
const loading = ref(true);
const searchResults = ref([]);

const itemCount = computed(() => {
  return searchResults.value?.reduce(function (acc, obj) {
    return acc + (obj.plants?.length || 0);
  }, 0);
});

onMounted(load);
watch(props, load);
watch(itemCount, emitCount);

function emitCount() {
  emit('update', {
    count: itemCount.value || 0,
    label: 'plants',
    loading: loading.value,
  });
}

async function load() {
  await loadOperations();
  loading.value = false;

  emitCount();
}

async function loadOperations() {
  let { ok, data } = await ajax(`/organisations/${props.organisationId}/operations`);

  if (ok) {
    listItems.value = JSON.parse(JSON.stringify(data.divisions));
    searchResults.value = data.divisions;
  }
}

function reload(data) {
  if (data?.type === 'delete') {
    listItems.value.forEach((division, index) => {
      division.plants = division?.plants.filter(operation => operation.id !== data?.id);
      searchResults.value[index].plants = searchResults.value[index]?.plants.filter(operation => operation.id !== data?.id);
    });
  }
}
</script>
